import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import ChipButton from '@/ui-components/ChipButton.vue';

import { CollectionType } from '@/enums/collection-type';

import { FilterValues, getUsedFilters, isAnyFilterActive } from '@/helpers/filter-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { useConstantStore, useFilterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterButtonSeo',
  props: {
    collectionType: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
};



const { filters } = useFilterStore();
const { ageCertifications } = useConstantStore();

const currentFilters = computed(() => filters.value(props.collectionType));

const filterValues = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { FilterProviders, ...filterValues } = FilterValues;

	if (!ageCertifications?.value.hasCertifications) {
		delete filterValues['FilterAgeCertification'];
	}
	return filterValues;
});

const hasActiveFilter = computed(() => {
	const usedFilters = getUsedFilters(filterValues.value);
	return isAnyFilterActive(usedFilters, currentFilters.value);
});

async function openFilterBarMenu(): Promise<void> {
	const { menuController } = await import('@/ionic.loader');

	menuController.open('filters');
	TrackingHelper.trackEvent('userinteraction', {
		action: 'filters_opened',
	});
}

return { __sfc: true,props, filters, ageCertifications, currentFilters, filterValues, hasActiveFilter, openFilterBarMenu, ChipButton }
}

})